<template>
  <a-button type="link" :loading="loadingStatus" @click="handleEventDeploy">{{title}}</a-button>

</template>

<script setup>
import {deployItem} from "@/api/common/deploy";
import {message} from "ant-design-vue";
import {ref} from "vue";

const loadingStatus = ref(false)
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
})

const handleEventDeploy = async () => {
  loadingStatus.value = true
  let params = {
  }
  const {data} = await deployItem(params)
  console.log('测试部署',data)
  message.success(data.message)
  loadingStatus.value = false
}

</script>

<style scoped>
.ant-btn-link{
  padding: 0 5px;
}
</style>